import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { UtilService } from './util.service';
import { Observable } from 'rxjs';
import { Bank } from '../models/bank.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  readonly rootURL = environment.ImpataAppAPIRoot;
  constructor(private http: HttpClient) { }

  initiateModulePayment(moduleId,batchId){
    return this.http.post(`${this.rootURL}payment/initiatemodulepayment`, { moduleId,batchId }, {headers: new HttpHeaders({ "content-type": "application/json", "accept": "application/json" })});
  }

  initiatePackagePayment(packageId){
    return this.http.post(`${this.rootURL}payment/initiatepackagepayment`, { packageId }, {headers: new HttpHeaders({ "content-type": "application/json", "accept": "application/json" })});
  }

  getBanks(){
    return this.http.get<Bank[]>(`${this.rootURL}payment/getbanks`);
  }

  initiateVCirclePayment(planid){
    return this.http.post(`${this.rootURL}payment/initiatevcirclepayment`, { planid }, {headers: new HttpHeaders({ "content-type": "application/json", "accept": "application/json" })});
  }

  initiateSchoolBillPayment(billId){
    //initiateschoolbillpayment
    return this.http.post(`${this.rootURL}payment/initiateschoolbillpayment`, { billId }, {headers: new HttpHeaders({ "content-type": "application/json", "accept": "application/json" })});
  }
}
